<template lang="pug">
  div(
    class="import import-excel"
    @click="showList=true"
    v-bind:class="{ dragging: dragInProgress }"
  )
    div(
      style="overflow-y: hidden;"
    ).body-wrapper
      div(v-if="userCanCreate").body.body-import
        div.col
          div(
            @drag.stop.prevent="onDragEnd"
            @dragover.stop.prevent="onDragStart"
            @dragstart.stop.prevent="onDragStart"
            @dragenter.stop.prevent="onDragStart"
            @dragend.stop.prevent="onDragEnd"
            @dragleave.stop.prevent="onDragEnd"
            @drop.stop.prevent="onFileDrop"
          ).upload-files
            div.upload
              div.upload-content
                div.icon
                div.info
                  p.blue Перетащите файлы в эту область
                  p Поддерживаемые форматы - xls,xlsx,doc,docx,pdf,jpg,zip,rar,7z
                div.file-upload
                  label.file-upload__label(for="upload") Загрузить
                  input(
                    type="file"
                    @change="addFile"
                    v-if="enableFileUpload"
                  ).file-upload__input
      div
        e-table-inner(
          ref="documents"
          :fetchDataFunction="fetchFiles"
          :visible-columns="columns"
          :show-edit-button="false"
          :show-checkbox="false"
          :show-footer="false"
          @deleteItem="deleteItem"
          no-data-message="Прикрепленных файлов нет"
        )
          template(
            slot="name"
            slot-scope="{ row }"
          )
            a(
              @click.prevent.stop="downloadFile(row)"
            ) {{row.name}}
          template(
            v-if="row"
            slot="actionButtons"
            slot-scope="{ row, rowIndex }"
          )
            div.buttons
              button(
                v-if="userCanDelete"
                @click="deleteItem(row, rowIndex)"
              ).row-delete
</template>

<script>
  import importMixin               from '@/app/import/mixins/import-mixin'
  import PublicInput               from '@/app/public-files/PublicInput'
  import { document_files, files } from '@/api/api-endpoints'
  import { ROOT_API }              from '@/config/config'
  
  export default {
    name:       'DocumentsTable',
    mixins:     [importMixin],
    props:      { documentIds: { type: Array, default: () => [] } }, //ссылки (id) на таблицу file
    components: { PublicInput },
    mounted() {},
    computed: {
      columns() {
        return {
          name: { label: 'Наименование файла' },
          ext:  { label: 'Формат' },
          size: { label: 'Размер, Мб' }
        }
      },
      items() { return this.$store.getters?.readUrlEndpoint(this.getEndpoint()) || { data: [], _meta: {} } },
      supportedFormat() { return ['xls', 'xlsx', 'doc', 'docx', 'jpg', 'png', 'gif', 'bmp', 'pdf', '7z', 'zip', 'rar'] }
    },
    methods:  {
      async fetchFiles() {
        const url = this.getEndpoint()
        this.$bar.start()
        return await Promise.all(this.documentIds?.length ? [
          this.$sharedServices.store.dispatch('postEndpoint', {
                                                url, data: { file_ids: this.documentIds.map(id => id) }
                                              }
          )] : []).then(r => {
          return r
        }).catch(e => Promise.reject(e)).finally(() => this.$bar.finish())
      },
      uploadFile(file, index = 0) {
        let fileName = file.name || index
        console.log('upload file')
        this.addToQueue(fileName)
        this.$store.dispatch('uploadFile', this.combineUploadData(file)).then(r => this.afterUpload(fileName, r)).catch(e => {
          this.removeFromQueue(fileName)
          this.$e.errorBox(e)
        })
      },
      combineUploadData(upload) { return { url: this.getUploadUrl(), data: { upload } } },
      afterUpload(fileName, response = {}) {
        this.removeFromQueue(fileName)
        this.$emit('documentsChanged', { ids: [...this.documentIds, response.id], document: response })
        this.$nextTick(() => this.$refs.documents.updateTable())
      },
      getEndpoint() { return document_files.list() },
      getDeleteUrl(id) { return files.one(id) },
      deleteItem(item) {
        this.$bar.start()
        this.$store.dispatch('deleteModel', { url: this.getDeleteUrl(item.id) }).then(() => {
          const filteredOfRemoved = this.documentIds.filter(v => v !== item.id)
          this.$emit('documentsChanged', { ids: filteredOfRemoved , deleted: item.id })
          this.$refs.documents.updateTable()
        }).catch(e => this.$e.errorBox(e)).finally(() => this.$bar.finish())
      },
      getUploadUrl() { return document_files.upload() },
      downloadFile(item) { this.download(`${ROOT_API.replace('/api/v1', '')}${item.url}`, item.name)},
      closeModal() {
        this.showModal = false
        this.fileId    = null
        this.fileName  = null
      }
    }
  }
</script>

<style scoped>

</style>